(function () {
  var modal = document.getElementById('gorilla-guarantee-modal');
  if (!modal) return;

  function openModal() {
    modal.classList.add('gorilla-guarantee-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('[data-guarantee-modal-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.classList.remove('gorilla-guarantee-modal--open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-guarantee-modal-open]').forEach(function (el) {
    el.addEventListener('click', openModal);
  });

  modal.querySelectorAll('[data-guarantee-modal-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('gorilla-guarantee-modal--open')) {
      closeModal();
    }
  });
})();
